import { render, staticRenderFns } from "./experience-dialog.vue?vue&type=template&id=bdccdd2c&"
import script from "./experience-dialog.vue?vue&type=script&lang=js&"
export * from "./experience-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports